import { render, staticRenderFns } from "./productform.vue?vue&type=template&id=48ddfea4&scoped=true&"
import script from "./productform.vue?vue&type=script&lang=js&"
export * from "./productform.vue?vue&type=script&lang=js&"
import style0 from "./productform.vue?vue&type=style&index=0&id=48ddfea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddfea4",
  null
  
)

export default component.exports